// extracted by mini-css-extract-plugin
export var avatar = "_mi-3";
export var avatarContainer = "_mi-2";
export var avatarSpacer = "_mi-5";
export var avatarSpacerContainer = "_mi-4";
export var avatarStackContainer = "_mi-1";
export var bubble = "_mi-0";
export var remainderBubble = "_mi-6";